import _ from 'lodash';
import { loadStatus } from '@/types';

import * as Loads from '@/types/models/load';
import bookedLoadMixin from './bookedLoadMixin';

export default {
  mixins: [bookedLoadMixin],
  methods: {
    facilityFlightBoardArrivals(company) {
      return _.chain(this.bookedLoads)
        .filter(bl => bl.loadStatus !== loadStatus.DELIVERED)
        // if arrivals, use dropoff company
        .filter(bl => Loads.dropoffCompany(bl) && Loads.dropoffCompany(bl).id)
        .filter(bl => Loads.dropoffLocation(bl) && Loads.dropoffLocation(bl).chute && parseInt(Loads.dropoffLocation(bl).chute.companyId, 10) === parseInt(company.id, 10))
        .value();
    },
    facilityFlightBoardDepartures(company) {
      return _.chain(this.bookedLoads)
        .filter(bl => bl.loadStatus === loadStatus.SCHEDULED)
        // if departures, use pickup company
        .filter(bl => Loads.pickupCompany(bl) && Loads.pickupCompany(bl).id)
        .filter(bl => Loads.pickupLocation(bl) && Loads.pickupLocation(bl).chute && parseInt(Loads.pickupLocation(bl).chute.companyId, 10) === parseInt(company.id, 10))
        .value();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/facilityFlightBoardMixin.js